export enum EmptyPlaceholderType {
    EmptyVideoPlaceholder = 'empty-video-placeholder',
    EmptyFilePlaceholder = 'empty-file-placeholder',
}
